document.addEventListener('DOMContentLoaded', function () {
  const allinputfields = document.querySelectorAll('.main-products-select');
  if(allinputfields){ 
  allinputfields.forEach(inputradioel => {
     inputradioel.checked = false; 
    inputradioel.removeAttribute('checked')
    console.log('removed')
  });
}


const deliverytypebuttons = document.querySelectorAll('.custom-header-deliver-btn');
const overlay = document.getElementById('deliveryOverlay');


if (deliverytypebuttons.length && overlay) {
  deliverytypebuttons.forEach((button) => {
    button.addEventListener('click', function () {
      overlay.classList.add('active');
      document.body.style.overflow = 'hidden';
    });
  });
}





  const allLabelRadio = document.querySelectorAll('.tiffin-prod-radio-label');
  if(allLabelRadio){ 
  allLabelRadio.forEach(lableradio => {
     lableradio.classList.remove('active')
    console.log('removed')
  });
}


const cartInputnote = document.querySelector('.cart-note-input')
if(cartInputnote){ 
  const inputVal = cartInputnote;
      const cartattributeinput = document.querySelector('#cart-note-attr');
      if (cartattributeinput) {
        cartattributeinput.value = inputVal;
      }
}


});

document.addEventListener('DOMContentLoaded', function() {
  const INACTIVITY_TIMEOUT = 10 * 60 * 1000; // 10 minutes
  let inactivityTimer;
  const redirectUrl = '/';

  // ===== 1. Handle Tab Close =====
  window.addEventListener('beforeunload', function() {
    localStorage.setItem('cartClearTime', Date.now());
  });

  // Check for expired cart on page load
  const clearTime = localStorage.getItem('cartClearTime');
  if (clearTime && (Date.now() - clearTime) > INACTIVITY_TIMEOUT) {
    clearCartAndRedirect();
  }

  // ===== 2. Handle User Inactivity =====
  function resetInactivityTimer() {
    clearTimeout(inactivityTimer);
    inactivityTimer = setTimeout(clearCartAndRedirect, INACTIVITY_TIMEOUT);
  }

  // Activity listeners
  ['mousemove', 'keydown', 'scroll', 'click', 'touchstart'].forEach(event => {
    window.addEventListener(event, resetInactivityTimer);
  });

  // Start initial timer
  resetInactivityTimer();

  // ===== Combined Clear & Redirect Function =====
  function clearCartAndRedirect() {
    fetch('/cart/clear.js', {
      method: 'POST',
      credentials: 'same-origin'
    })
    .then(() => {
      localStorage.removeItem('cartClearTime');
      localStorage.removeItem('selectedTiffins');
      window.location.href = redirectUrl;
    })
    .catch(error => console.error('Error:', error));
  }

  // Show warning 1 minute before clearing (optional)
  setTimeout(() => {
    console.log('Your cart will be cleared in 1 minute due to inactivity');
  }, INACTIVITY_TIMEOUT - 60000);
});

document.addEventListener('DOMContentLoaded', async function() {
  // Check for cart clearance flag
  const shouldClear = await fetch('/cart.js')
    .then(res => res.json())
    .then(cart => {
      return cart.attributes?.cartCleared === 'true';
    });

  if (shouldClear) {
    // Clear the cart
    await fetch('/cart/clear.js', { method: 'POST' });
          localStorage.removeItem('selectedTiffins');

    // Remove the attribute
    await fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        attributes: { cartCleared: null }
      })
    });
  }
});